export default "__VITE_ASSET__3rsb2xKa__"